export enum ReportPeriods {
	CURRENT = 'period_1_',
	HISTORIC = 'period_2_'
}
